import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to reports page after 5 seconds
    const timer = setTimeout(() => {
      navigate('/reports');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircleIcon className="h-16 w-16 text-green-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Subscription Successful!
        </h2>
        <p className="text-gray-600 mb-6">
          Thank you for subscribing. Your account has been upgraded and you now have access to security reports and premium features.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/reports')}
            className="w-full bg-blue-600 text-white px-4 py-2 rounded-md font-medium hover:bg-blue-700 transition-colors"
          >
            View Security Reports
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gray-100 text-gray-700 px-4 py-2 rounded-md font-medium hover:bg-gray-200 transition-colors"
          >
            Go to Dashboard
          </button>
        </div>
        <p className="mt-6 text-sm text-gray-500">
          Redirecting to reports in 5 seconds...
        </p>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPage;
